// src/components/MonthDivider.jsx
import React from 'react';

const MonthDivider = ({ month, isDarkMode }) => {
  return (
    <div className="w-full flex items-center my-6 px-4">
      <div className={`h-px flex-grow ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
      <span className={`px-4 text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        {month}
      </span>
      <div className={`h-px flex-grow ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
    </div>
  );
};

export default MonthDivider;